
import "./UiHeadline.css";

import { computed, defineComponent, PropType } from "vue";

import { usePlatform } from "@/hooks/usePlatform";
import { getClassName } from "@/lib/getClassName";

type HeadlineWeight = "semibold" | "medium" | "regular";

export default defineComponent({
  inheritAttrs: false,

  props: {
    weight: { type: String as PropType<HeadlineWeight>, default: "regular" },
    tag: { type: String, default: "h3" },
  },

  setup(props) {
    const platform = usePlatform();

    const rootClasses = computed(() => [
      getClassName("UiHeadline", platform),
      `UiHeadline--w-${props.weight}`,
      {},
    ]);

    return {
      props,
      rootClasses,
    };
  },
});
